import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.scss'],
})
export class TokenComponent implements OnInit {
  @Output() controleExibicao = new EventEmitter<boolean>();
  public token: string[] = [];
  public obtendoToken: boolean = false;

  constructor(private fidelidade: FidelidadeService) {}

  ngOnInit(): void {
    this.obterToken();
  }

  private obterToken(): void {
    this.obtendoToken = true;
    this.fidelidade.obterToken().subscribe(
      (res) => this.processarSucessoToken(res),
      (err) => this.processarFalhaToken(err)
    );
  }

  private processarSucessoToken(res: any): void {
    for (var i = 0; i < res.token.length; i++) {
      this.token.push(res.token[i]);
    }
    this.obtendoToken = false;
  }

  private processarFalhaToken(err: any): void {
    this.obtendoToken = false;
    console.error('Ocorreu um erro ao gerar o token', err);
    this.fecharPopup();
  }

  fecharPopup(): void {
    this.controleExibicao.emit(false);
  }
}
